import type { FC } from 'react';
import { CabinetTitlePage } from 'components/layout';
import { AddCreativeTextTT } from 'features/cabinet';
import { Guard, usePermissionGuard } from 'features/login';

const AddCreativeTextPage: FC = () => {
  const { accessToAddTiktoktext } = usePermissionGuard();
  return (
    <Guard hasAccess={accessToAddTiktoktext}>
      <CabinetTitlePage
        title={'Creative texts'}
        goBack={'/cabinet/tiktok/creative-texts'}
      />
      <AddCreativeTextTT />
    </Guard>
  );
};

export default AddCreativeTextPage;
